import React from 'react'
import '../CSS/Records.css'
import styles from '../CSS/AgentHome.module.css';

import { useState } from 'react';

import { useAuth } from '../AuthContext';
import { useRef } from 'react';
import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { GoArrowRight } from "react-icons/go";

import Loading from '../Components/Loading';
import Error from '../Components/Error';

const DepositRec = () => {
    const navigate = useNavigate()
    const { fetchData } = useAuth();

    const [records, setRecords] = useState([])

    const [loader, setLoader] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorText, setErrorText] = useState('');


    const [todayDepo, setTodayDepo] = useState({
        usdt: 0,
        trx: 0
    })

    const [yestedayDepo, setYesterdayDepo] = useState({
        usdt: 0,
        trx: 0
    })

    const [totalDepo, setTotalDepo] = useState({
        usdt: 0,
        trx: 0,
        no: 0
    })

    const recordsPerPage = 100;
    const [currentPage, setCurrentPage] = useState(1);
    const totalPages = Math.ceil(totalDepo.no / recordsPerPage);

    const displayError = (message) => {
        setIsError(true);
        setErrorText(message);

        const timerId = setTimeout(() => {
            setIsError(false);
            setErrorText('');
        }, 1500);

        return () => clearTimeout(timerId);
    };

    async function getData(page = 1) {
        setLoader(true);

        try {
            const data = await fetchData('/admin/recharge/list?page=' + page);
            setLoader(false);

            setTodayDepo(data.todayPayout);
            setYesterdayDepo(data.yesterdayPayout);
            setTotalDepo(data.totalPayout)

            setRecords(data.records || []);

        } catch (error) {
            setLoader(false);
            displayError(error.message)
        }
    }

    useEffect(() => {
        getData(currentPage)
    }, [])


    const goToPage = (pageNum) => {
        if (pageNum >= 1 && pageNum <= totalPages && pageNum !== currentPage) {
            setCurrentPage(pageNum);
        }
    };

    const renderPagination = () => {
        const pages = [];
        const edgeCount = 3;

        const addPage = (p) => {
            pages.push(
                <button
                    key={p}
                    onClick={() => goToPage(p)}
                    className={p === currentPage ? "active" : ""}
                >
                    {p}
                </button>
            );
        };

        pages.push(
            <button onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1} key="prev">
                &lt;
            </button>
        );

        for (let i = 1; i <= Math.min(edgeCount, totalPages); i++) addPage(i);

        if (currentPage > edgeCount + 1) pages.push(<span key="start-ellipsis">...</span>);

        const startMiddle = Math.max(edgeCount + 1, currentPage - 1);
        const endMiddle = Math.min(totalPages - edgeCount, currentPage + 1);

        for (let i = startMiddle; i <= endMiddle; i++) {
            if (i <= totalPages) addPage(i);
        }

        if (currentPage < totalPages - edgeCount) pages.push(<span key="end-ellipsis">...</span>);

        for (let i = totalPages - edgeCount + 1; i <= totalPages; i++) {
            if (i > edgeCount) addPage(i);
        }

        pages.push(
            <button onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages} key="next">
                &gt;
            </button>
        );

        return <div className="pagination">{pages}</div>;
    };

    return (
        <div className='dashboard'>
            {loader && <Loading />}
            {isError && <Error errorMsg={errorText} />}

            <div className={styles.topbar}>
                <div className={styles.left}>
                    <h1>Deposit Records</h1>
                </div>

                <div className={styles.right} style={{
                    display: "flex",
                    alignItems: "center",
                }} onClick={() => navigate(-1)}>
                    <div>Go Back</div>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: 20
                    }}>
                        <GoArrowRight />
                    </div>
                </div>
            </div>

            <div className="summary-container">
                <div className="card">
                    <h2>Total Deposit's</h2>
                    <p className="amount">${totalDepo.usdt}<span> USD</span></p>
                    <p>Trx deposits: {totalDepo.trx} TRON</p>
                </div>
                <div className="card">
                    <h2>Today's Deposit</h2>
                    <p className="amount">${todayDepo.usdt}<span> USD</span></p>
                    <p>Trx deposits: {todayDepo.trx} TRON</p>
                </div>
                <div className="card">
                    <h2>Yesterday's Deposit</h2>
                    <p className="amount">${yestedayDepo.usdt}<span> USD</span></p>
                    <p>Trx deposits: {yestedayDepo.trx} TRON</p>
                </div>
            </div>

            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Order ID</th>
                            <th>Amount</th>
                            <th>Type</th>
                            <th>Details</th>
                            <th>Recharges</th>
                            <th>Withdrawals</th>
                        </tr>
                    </thead>
                    <tbody>
                        {records.map((w, i) => (
                            <tr key={i}>
                                <td>
                                    <div>{w.orderId}</div>
                                    <div className="subtext">{w.date}</div>
                                </td>
                                <td>
                                    <div>{w.method !== 'TRX-TRC20' && '$'}{w.method === 'TRX-TRC20' ? w.convertedAmount : w.amount} {w.method === 'TRX-TRC20' && 'TRX'}</div>
                                    <div className="subtext">Account ID: {w.id}</div>
                                </td>
                                <td>
                                    <div>{['TRX-TRC20', 'USDT-TRC20'].includes(w.method) ? 'Crypto' : 'Bank Transfer'}</div>
                                    <div className="subtext">method: {w.method}</div>
                                </td>
                                {w.method === 'Bank Transfer' ? <td>
                                    <div>{w.details?.bankName}</div>
                                    <div className="subtext">{w.details?.accountNo}</div>
                                    <div className="subtext">{w.details?.holderName}</div>
                                </td> : <td>
                                    <div>{w.details?.address}</div>
                                    <div className="subtext">Hash: {w.details?.hash}</div>
                                </td>}
                                <td>
                                    <div>${w.recharges}</div>
                                </td>
                                <td>
                                    <div>${w.payouts}</div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {renderPagination()}
        </div>
    )
}

export default DepositRec